export const removeAddedOption = (options) => {
  return options.filter((option) => option.merchantNominaId !== "");
};
